import { apiService } from './api';
import { PaginationParams } from '../types';

export interface RolePermissionDTO {
  id: number;
  code: string;
  name: string;
  description: string;
  module: string;
}

export interface RoleDTO {
  id: number;
  name: string;
  description: string;
  isSystem: boolean;
  permissions: RolePermissionDTO[];
}

export interface UserDTO {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  lastLogin?: string;
  roles: RoleDTO[];
  outletId?: number | null;
  hasPin: boolean;
}

export interface CreateUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  roleIds: number[];
  outletId?: number | null;
}

export interface UpdateUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  roleIds: number[];
  outletId?: number | null;
}

const USERS_API = '/users';

export const userService = {
  getUsers: (params: PaginationParams) =>
    apiService.get<UserDTO[]>(USERS_API, {
      pageNumber: params.pageNumber || 1,
      pageSize: params.pageSize || 100,
    }),

  getUserById: (id: string | number) =>
    apiService.get<UserDTO>(`${USERS_API}/${id}`),

  createUser: (data: CreateUserRequest) =>
    apiService.post<UserDTO>(USERS_API, data),

  updateUser: (id: string | number, data: UpdateUserRequest) =>
    apiService.put<UserDTO>(`${USERS_API}/${id}`, data),

  activateUser: (id: string | number) =>
    apiService.patch<void>(`${USERS_API}/${id}/activate`, {}),

  deactivateUser: (id: string | number) =>
    apiService.patch<void>(`${USERS_API}/${id}/deactivate`, {}),

  getRoles: () =>
    apiService.get<RoleDTO[]>('/users/roles'),

  getUserApps: (id: string | number) =>
    apiService.get<string[]>(`/users/${id}/apps`),

  setUserApps: (id: string | number, appCodes: string[]) =>
    apiService.put<void>(`/users/${id}/apps`, appCodes),

  getCompanyApps: (companyId: number) =>
    apiService.get<string[]>(`/companies/${companyId}/apps`),

  setPin: (id: string | number, pin: string) =>
    apiService.put<void>(`${USERS_API}/${id}/pin`, { pin }),
};
